import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Alert } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    // Prüfen ob PWA bereits installiert ist
    if (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) {
      return; // PWA bereits installiert
    }

    // Event Listener für beforeinstallprompt
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallPrompt(true);
    };

    // Event Listener für appinstalled
    const handleAppInstalled = () => {
      setShowInstallPrompt(false);
      setDeferredPrompt(null);
      Alert.alert('Erfolg', 'App wurde erfolgreich installiert!');
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    // Zeige den Installationsprompt
    deferredPrompt.prompt();
    
    // Warte auf die Benutzerentscheidung
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    
    setDeferredPrompt(null);
    setShowInstallPrompt(false);
  };

  const handleDismiss = () => {
    setShowInstallPrompt(false);
    // Speichere in localStorage, dass der Benutzer den Prompt abgelehnt hat
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  // Prüfe ob der Prompt bereits abgelehnt wurde
  useEffect(() => {
    const dismissed = localStorage.getItem('pwa-install-dismissed');
    if (dismissed === 'true') {
      setShowInstallPrompt(false);
    }
  }, []);

  if (!showInstallPrompt || !deferredPrompt) {
    return null;
  }

  return (
    <View style={styles.installPrompt}>
      <View style={styles.installContent}>
        <View style={styles.installIcon}>
          <Ionicons name="download-outline" size={24} color="#2E7D32" />
        </View>
        <View style={styles.installText}>
          <Text style={styles.installTitle}>App installieren</Text>
          <Text style={styles.installDescription}>
            Installiere Gambalunga Einkauf für bessere Performance und Offline-Zugriff
          </Text>
        </View>
        <View style={styles.installActions}>
          <TouchableOpacity
            style={styles.dismissButton}
            onPress={handleDismiss}
          >
            <Ionicons name="close" size={20} color="#666" />
          </TouchableOpacity>
          <TouchableOpacity
            style={styles.installButton}
            onPress={handleInstallClick}
          >
            <Text style={styles.installButtonText}>Installieren</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  installPrompt: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    right: 20,
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 8,
    zIndex: 1000,
    borderWidth: 1,
    borderColor: '#e0e0e0',
  },
  installContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  installIcon: {
    marginRight: 12,
  },
  installText: {
    flex: 1,
  },
  installTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginBottom: 4,
  },
  installDescription: {
    fontSize: 14,
    color: '#666',
    lineHeight: 20,
  },
  installActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  dismissButton: {
    padding: 8,
  },
  installButton: {
    backgroundColor: '#2E7D32',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  installButtonText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
  },
});

export default PWAInstallPrompt;
